"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateEntityDialog = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const create_entity_dialog_skeleton_component_1 = require("./create-entity-dialog-skeleton.component");
const create_entity_dialog_styles_1 = require("./create-entity-dialog.styles");
const create_entity_form_1 = require("./create-entity-form");
const CreateAttributeFormConstants = __importStar(require("./create-entity-form/create-attribute-form.constants"));
const partials_1 = require("./create-entity-form/partials");
const form_observer_component_1 = require("./form-observer.component");
const global_tree_edit_warning_1 = require("../../components/global-tree-edit-warning");
const global_tree_edit_warning_form_constants_1 = require("../../components/global-tree-edit-warning/global-tree-edit-warning-form.constants");
const generic_1 = require("..");
const localization_1 = require("../../../localization");
const store_1 = require("../../../store");
const { AttributeFormFieldNames, attributeInitialValues } = CreateAttributeFormConstants;
const CreateEntityDialog = ({ formId, validationSchema, title, attributesOptionList, isLoading, initialValues = attributeInitialValues, hideDescription, valueOptionListStrategyNodeId, selectedStrategyNodeId, allowCreation, isReadOnly, isValueListHeightDynamic, matchedValueNames, loadedValueItems, valuesLoading, valuesHasNextPage, valuesMoreItemsLoading, valueSectionLabels, onValuesLoadMore, onValueSearch, onSubmit, onClose, onChange, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const shouldShowGlobalTreeEditWarning = (0, store_1.useShouldShowGlobalTreeEditWarning)();
    return (react_1.default.createElement(ui_components_1.Form, { enableReinitialize: true, validateOnBlur: true, initialValues: Object.assign(Object.assign({}, global_tree_edit_warning_form_constants_1.globalTreeEditWarningFormInitialValues), initialValues), validationSchema: validationSchema, handleSubmit: (values) => onSubmit(values) }, ({ isSubmitting, isValid, dirty, values, setFieldValue, handleSubmit, resetForm, }) => {
        const isDialogContentScrollable = isValueListHeightDynamic || values[AttributeFormFieldNames.Attributes].length > 1;
        return (react_1.default.createElement(react_1.default.Fragment, null, onChange && react_1.default.createElement(form_observer_component_1.FormObserver, { onChange: onChange }), react_1.default.createElement("form", { id: formId }, react_1.default.createElement(create_entity_dialog_styles_1.StyledDialog, { "$withGlobalTreeEditWarning": shouldShowGlobalTreeEditWarning, open: true, fullWidth: true, maxWidth: false, proceedButtonProps: {
                title: t({ key: allowCreation ? 'ADD' : 'UPDATE' }),
                disabled: isReadOnly || isSubmitting || !isValid || !dirty,
                endIcon: isSubmitting && react_1.default.createElement(generic_1.LoadingIndicator, null),
                onClick: () => handleSubmit(),
            }, cancelButtonProps: {
                title: t({ key: 'CANCEL' }),
                onClick: () => {
                    resetForm();
                    onClose();
                },
            }, title: typeof title === 'function' ? title({ values, setFieldValue }) : title }, react_1.default.createElement(generic_1.ActionDialogContainer, null, react_1.default.createElement(create_entity_dialog_styles_1.StyledDialogContent, { "$isScrollable": isDialogContentScrollable }, isLoading && (react_1.default.createElement(create_entity_dialog_skeleton_component_1.CreateEntityDialogSkeleton, null)), !isLoading && (react_1.default.createElement(partials_1.FormListManager, { name: AttributeFormFieldNames.Attributes, component: create_entity_form_1.AttributeFormListContainer, componentProps: {
                allowCreation,
                isReadOnly,
                isValueListHeightDynamic,
                hideDescription,
                valueOptionListStrategyNodeId,
                selectedStrategyNodeId,
                attributesOptionList,
                matchedValueNames,
                loadedValueItems,
                valuesLoading,
                valuesHasNextPage,
                valuesMoreItemsLoading,
                valueSectionLabels,
                onValuesLoadMore,
                onValueSearch,
            } }))), shouldShowGlobalTreeEditWarning && (react_1.default.createElement(global_tree_edit_warning_1.GlobalTreeEditWarning, { isChecked: Boolean(values[global_tree_edit_warning_form_constants_1.GlobalTreeEditWarningFormFieldNames.isGlobalStrategyReplacementAccepted]), disabled: isReadOnly, onChange: (value) => setFieldValue(global_tree_edit_warning_form_constants_1.GlobalTreeEditWarningFormFieldNames.isGlobalStrategyReplacementAccepted, value, true) })))))));
    }));
};
exports.CreateEntityDialog = CreateEntityDialog;
exports.default = exports.CreateEntityDialog;
